import Component from './z-select.vue';
export default Component;
